<template>
  <div class="role">

    <!-- 新增菜单 -->
    <el-button type="primary" size="small" class="addBtn" @click="addMenus()">添加子菜单</el-button>

    <el-table :data="menus" row-key="id" :tree-props="{ children: 'son' }">

      <!-- :height="mainHeight-218+'px'" -->
      <el-table-column label="编号" prop="id"></el-table-column>



      <el-table-column label="菜单名称" prop="name" min-width="180px"></el-table-column>

      <el-table-column label="英文名称" prop="en_name" min-width="180px">
        <template slot-scope="scope">
          <div :title="scope.row.en_name">{{ scope.row.en_name }}</div>
        </template>
      </el-table-column>

      <el-table-column label="路由" prop="url" min-width="180px"></el-table-column>

      <el-table-column label="图标">
        <template slot-scope="scope">
          <img v-if="scope.row.icon.indexOf('.png') != -1" :src="require('@/assets/images/' + scope.row.icon)"
            class="icon" />
          <span v-else>{{ scope.row.icon }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否显示">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.display == 1" type="success">显示</el-tag>
          <el-tag v-else type="danger">隐藏</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="父节点" prop="pid"></el-table-column>
      <el-table-column label="排序" prop="sort">
      </el-table-column>
      <el-table-column label="操作" min-width='180px' fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" class="editBtn" @click="editMenus(scope.row)">编辑</el-button>
          <el-button type="primary" size="small" class="addBtn" v-if="scope.row.pid == 0"
            @click="addMenus(scope.row)">添加子菜单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @current-change="pageChange" :current-page.sync="pager.page" hide-on-single-page
      :page-size="pager.pagesize" prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper"
      :total="pager.count">
    </el-pagination>

    <!-- 新增、修改弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="isAlert" width="600px" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" hide-required-asterisk ref="form" label-width="120px">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="formData.name" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="英文名称" prop="en_name">
          <el-input v-model="formData.en_name" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="根菜单" prop="pid" v-if="isChildMenus || isEditSonMenu">
          <el-select v-model="formData.pid">
            <el-option v-for="item in topMenus" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图标名称" prop="icon">
          <el-input v-model="formData.icon" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="路由名称" prop="url" v-if="isChildMenus">
          <el-input v-model="formData.url" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model="formData.sort" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="是否显示" prop="display">
          <el-radio v-model="formData.display" label="1">显示</el-radio>
          <el-radio v-model="formData.display" label="0">隐藏</el-radio>
        </el-form-item>

      </el-form>

      <div class="dialog-footer">
        <el-button class="cancel-btn" @click="formCancel">取消</el-button>
        <el-button class="submit-btn" @click="formSubmit">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { adminMenu } from "@/utils/axios"

export default {
  name: 'adminMenu',
  data () {
    return {
      isAlert: false,
      oper: '',
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
      formData: {
        name: '',
        en_name: '',
        pid: '',// 父级id 必传 顶级目录 0，不是则传选中目录id
        icon: '',
        url: '',
        sort: 100,
        display: '1'
      },
      rules: {
        name: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        en_name: [
          { required: false, message: '英文名称不能为空', trigger: 'blur' }
        ],

        pid: [
          { required: true, message: '请选择根菜单', trigger: 'change' }
        ],
        display: [
          { required: true, message: '是否显示必选', trigger: 'change' }
        ]
      },


      menus: [],

      topMenus: [],// 一级菜单列表

      pager: {
        page: 1,
        pagesize: 12,
        count: 0
      },
      dialogTitle: "操作菜单",
      isChildMenus: false,
      isEditSonMenu: false

    }
  },
  watch: {

    'formData.name': {
      handler (val) {
        if (val) {
          this.formData.name = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.en_name': {
      handler (val) {
        if (val) {
          this.formData.en_name = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.icon': {
      handler (val) {
        if (val) {
          this.formData.icon = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.url': {
      handler (val) {
        if (val) {
          this.formData.url = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.sort': {
      handler (val) {
        if (val && typeof val == 'string') {
          this.formData.sort = val.replace(/(\s|[^\d])+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {

    getTopMenus () {
      const data = {
        act: "topMenu"
      }
      adminMenu(data).then(res => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.topMenus = result;
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },
    // 获取列表
    getList () {
      adminMenu(this.pager).then(res => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.menus = result.data;
          this.pager = result.pager;

          // 数值可能为字符串，需转换为number
          for (var key in this.pager) {
            this.pager[key] = parseInt(this.pager[key]);
          }
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },

    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },

    // 参数：修改(edit)或添加(add)
    showDialog (oper, id) {
      this.oper = oper;
      this.isAlert = true;

      if (oper == 'add') {
        this.dialogTitle = `增加根菜单`
        if (this.formData.pid || this.formData.name) {
          this.$refs.form.resetFields();// 重置表单
        }
      } else if (oper == 'edit') {
        adminMenu({
          act: 'query',
          id: id
        }).then(res => {
          if (res.code == 200) {
            let result = JSON.parse(window.atob(res.data))
            this.formData = result;


          } else {
            this.$myAlert({
              type: 'fail',
              title: res.msg
            });
          }
        });
      }

    },
    addMenus (row = {}) {
      this.oper = 'add'
      this.formData.id = undefined

      this.formData = {
        sort: 100
      }

      console.log(row);


      if (row.pid && row.pid === '0') {
        this.isEditSonMenu = true
      } else {
        this.isEditSonMenu = false
      }

      if (row.id) {
        this.getTopMenus()
        this.formData.pid = row.id
        this.dialogTitle = `添加子菜单`
        this.isChildMenus = false
      } else {
        this.formData.pid = 0
        this.dialogTitle = `新增根菜单`
        this.isChildMenus = false
      }
      this.isAlert = true;
    },
    editMenus ({ id, pid }, title) {
      if (!id) return
      if (pid != '0') {
        this.isChildMenus = true
        this.isEditSonMenu = true
      } else {
        this.isChildMenus = false
        this.isEditSonMenu = false
      }

      this.dialogTitle = title || `编辑菜单`
      this.isChildMenus = false

      adminMenu({
        act: 'detail',
        id: id
      }).then(res => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.formData = result;
          this.oper = 'edit'
          if (this.formData.pid && this.formData.pid != 0) {
            this.isChildMenus = true
          }
          this.isAlert = true;
          this.getTopMenus()
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },

    menuChange (key, data) {
      this.formData.menus = data.checkedKeys;
    },

    formCancel () {
      this.isAlert = false;
      this.$refs.form.resetFields();// 重置表单
    },

    formSubmit () {
      const acts = ['update', 'add', 'addSon', 'updateSon']
      this.$refs.form.validate(isSuc => {
        if (isSuc) {
          const data = JSON.parse(JSON.stringify(this.formData))
          if (data.id) {
            if (data.pid == 0) {
              data.act = 'update'
            } else {
              data.act = 'updateSon'
            }
          } else {
            if (data.pid == 0) {
              data.act = 'add'
            } else {
              data.act = 'addSon'
            }
          }


          adminMenu(data).then(res => {
            if (res.code == 200) {
              this.isAlert = false;
              this.getList();

              this.$myAlert({
                type: 'success',
                title: (this.oper == 'add' ? '添加' : '修改') + '成功'
              });
            } else {
              this.$myAlert({
                type: 'fail',
                title: res.msg
              });
            }
          });
        }
      });
    },

    remove () {
      this.$myAlert({
        title: '确定删除？',
        callback: () => {// 点击确认触发
        }
      });
    }
  }
}
</script>

<style scoped>
.el-dialog .el-form>>>.el-form-item__label {
  text-align: right;
}

.el-dialog .el-form>>>.el-form-item__content {}

.role>>>.cell {
  white-space: nowrap !important;
}
</style>
<style lang="scss" scoped>
.role {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 28px 24px;

  .add {
    padding: 8px 12px;
    margin: 24px 0 12px;
    color: #fff;
  }

  .el-table {
    i[class^=el-icon] {
      margin-right: 16px;
      cursor: pointer;
    }

    .icon {
      width: 24px;
      height: auto;
    }

    .cell {
      white-space: nowrap !important;
    }
  }

  .foot-pagination {
    // position: absolute;
    // bottom: 0;
    width: 96%;
    // height: 80px;
  }


  .el-dialog {
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .cancel-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6883FB;
        border: 1px solid #6883FB;
        border-radius: 17px;
        background-color: #fff;
      }

      .submit-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        border: none;
        border-radius: 17px;
        background-color: #6883FB;
        margin-left: 16px;
      }

      .el-button {
        font-size: 16px;
      }
    }
  }
}

.addChildMenus {
  margin-right: 12px;
  color: #6883FB;
  float: left;
  cursor: pointer;
}
</style>
